import { StoreState } from '../../../../store/store.interface';

export const isPaypalEnabled = (state: StoreState) => !!state.shopCheckoutState.clientToken.data?.paypalEnabled;
